var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkinghours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.186,
    height: 35.607,
    viewBox: "0 0 36.186 35.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.186,
    height: 35.607,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "working_hours",
    "data-name": "working hours",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9531",
    "data-name": "Ellipse 9531",
    transform: "translate(17.772 16.568)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 9.207,
    ry: 9.207,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 8.707,
    ry: 8.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    "data-name": "Path 4422",
    d: "M9.473.127A.547.547,0,0,0,8.7.2L4.208,4.158.934,2.415a.547.547,0,0,0-.774.774l3.7,2.166a.547.547,0,0,0,.387.16h.025a.548.548,0,0,0,.4-.2L9.544.9A.547.547,0,0,0,9.473.127Z",
    transform: "translate(21.071 26.198) rotate(-48)",
    fill: "#c4151c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_72",
    "data-name": "Union 72",
    transform: "translate(11.708 0) rotate(21)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.385,32.67a3,3,0,0,1-3-3V12.392A7.128,7.128,0,0,1,0,5.813C.083-.458,1-.216,2.785.162S3.972,7.326,7.125,7.326C11.206,7.39,9.775.611,11.557.232S14.181.08,14.251,5.813a7.12,7.12,0,0,1-3.289,6.005V29.669a3,3,0,0,1-3,3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.962300300598145 31.67000198364258 C 9.064940452575684 31.67000198364258 9.962000846862793 30.77253150939941 9.962000846862793 29.66940116882324 L 9.962000846862793 11.8183012008667 L 9.962000846862793 11.27114105224609 L 10.42281055450439 10.9761209487915 C 12.19175148010254 9.843588829040527 13.24853515625 7.916080474853516 13.25059700012207 5.819181442260742 C 13.22440242767334 3.670573472976685 13.08448028564453 2.270661115646362 12.82286071777344 1.539341330528259 C 12.67119026184082 1.115371346473694 12.5959300994873 1.115371346473694 12.43102073669434 1.115371346473694 C 12.265549659729 1.115371346473694 12.0487585067749 1.152396202087402 11.85936164855957 1.190714478492737 C 11.67725944519043 1.469975471496582 11.51155662536621 2.393100023269653 11.39974021911621 3.016051292419434 C 11.20722007751465 4.0885910987854 10.98901081085205 5.3042311668396 10.45686054229736 6.310331344604492 C 9.575510025024414 7.97667121887207 8.18971061706543 8.326451301574707 7.182360172271729 8.326451301574707 C 7.16108512878418 8.326451301574707 7.139049530029297 8.326300621032715 7.117388725280762 8.325991630554199 C 5.920920848846436 8.323172569274902 4.973118782043457 7.680365562438965 4.300210475921631 6.415301322937012 C 3.810050487518311 5.493801116943359 3.518850326538086 4.339361190795898 3.26192045211792 3.32081127166748 C 3.114330291748047 2.735701322555542 2.974920511245728 2.183031320571899 2.818340301513672 1.747611284255981 C 2.670703411102295 1.337071895599365 2.558344602584839 1.178701043128967 2.51339054107666 1.126707673072815 C 2.2033371925354 1.060901641845703 1.912171244621277 1.000121355056763 1.720460414886475 1.000121355056763 C 1.65984034538269 1.000121355056763 1.630621433258057 1.006358027458191 1.621163368225098 1.008926510810852 C 1.597357392311096 1.030508518218994 1.426173210144043 1.209047913551331 1.274900436401367 1.986401319503784 C 1.113207817077637 2.81727409362793 1.023282170295715 4.071058750152588 1.000004053115845 5.819246768951416 C 1.002530217170715 8.297351837158203 2.481687307357788 10.51475715637207 4.769800186157227 11.46925163269043 L 5.384800434112549 11.72580146789551 L 5.384800434112549 12.39217090606689 L 5.384800434112549 29.66940116882324 C 5.384800434112549 30.77253150939941 6.2818603515625 31.67000198364258 7.384500503540039 31.67000198364258 L 7.962300300598145 31.67000198364258 M 7.962300300598145 32.67000198364258 L 7.384500503540039 32.67000198364258 C 5.727600574493408 32.67000198364258 4.384800434112549 31.32630157470703 4.384800434112549 29.66940116882324 L 4.384800434112549 12.39217090606689 C 1.810190439224243 11.31816101074219 4.07409658009783e-07 8.776691436767578 4.07409658009783e-07 5.813101291656494 C 0.06432909518480301 0.9409025311470032 0.633888304233551 0.000116426388558466 1.720459580421448 0.000116426388558466 C 2.03245735168457 0.000116426388558466 2.387065649032593 0.07767574489116669 2.784600496292114 0.1620013117790222 C 4.565700531005859 0.5409013032913208 3.971700429916382 7.326001167297363 7.125300407409668 7.326001167297363 C 7.144228935241699 7.326297760009766 7.163665294647217 7.326450347900391 7.182357788085938 7.326450347900391 C 11.19332027435303 7.326450347900391 9.783166885375977 0.6093437075614929 11.55690002441406 0.2322013080120087 C 11.87846374511719 0.1639564335346222 12.16963386535645 0.115374356508255 12.4310245513916 0.115374356508255 C 13.61744785308838 0.115374356508255 14.19381237030029 1.115148544311523 14.25060081481934 5.813101291656494 C 14.25060081481934 8.335511207580566 12.93981075286865 10.55205154418945 10.96200084686279 11.8183012008667 L 10.96200084686279 29.66940116882324 C 10.96200084686279 31.32630157470703 9.619200706481934 32.67000198364258 7.962300300598145 32.67000198364258 Z",
    stroke: "none",
    fill: "#c4151c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9532",
    "data-name": "Ellipse 9532",
    transform: "translate(6.697 28.092)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.743,
    cy: 1.743,
    rx: 1.743,
    ry: 1.743,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.743,
    cy: 1.743,
    rx: 1.243,
    ry: 1.243,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkinghours);
export default __webpack_public_path__ + "static/media/workinghours.268171298db9cb34d44723e38792cb35.svg";
export { ForwardRef as ReactComponent };